export default __webpack_public_path__ + "static/media/card2.6fc65f41.png";